'use client';

import { useEffect } from 'react';
const Logout = () => {
  useEffect(() => {
    if (document.cookie) {
      document.cookie = 'access_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    }
  }, []);
  return <div data-sentry-component="Logout" data-sentry-source-file="Logout.tsx"></div>;
};
export default Logout;